import { Component } from '@angular/core';
import { OnlinekeyRequestedCardTableModel } from './onlinekey-requested-card-table.model';

@Component({
  selector: 'app-detail-table',
  templateUrl: './onlinekey-requested-card-table.component.html',
  styleUrls: ['../../../detail-screen/detail-screen.component.css'],
})
export class OnlinekeyRequestedCardTableComponent {
  restrictedData: boolean;
  tableColumns: string[];
  tableData: OnlinekeyRequestedCardTableModel[];
  emptyValuePlaceholder = '-';
  errorText: string;
  showTable: boolean;

  constructor() {
    this.tableColumns = [];
    this.tableData = [];
  }

  getNotificationDateTime(data:any){
    let notificationDateTime = '-';
    if(data.pinMailer && data.pinMailer.status == 'Verzonden'){
      notificationDateTime = data.pinMailer.notificationDateTime;
    } else if (data.notificationPassFactoryDateTime) {
      notificationDateTime = data.notificationPassFactoryDateTime;
    }
    return notificationDateTime;
  }
}
